import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { FileActionButton } from './file_upload.styled';

const FileUploadProgress = ({ currentFile, uploadState, progress, cancelUpload }) => {
  const offLine = useSelector((state) => state.form.offLine);

  return (
    <div style={{ width: `${100}%` }}>
      <div className="ui teal progress active">
        <div
          className="bar"
          style={{
            transitionDuration: `${300}ms`,
            width: `${progress?.loaded / currentFile.size > 1 ? 100 : (progress?.loaded / currentFile.size) * 100}%`,
          }}>
          <div className="progress">{progress?.humanSize}</div>
        </div>

        {!offLine && uploadState.uploading && (
          <div className="label" style={{ fontWeight: 100 }}>
            Uploading {currentFile.name}
            <FileActionButton type="button" onClick={cancelUpload}>
              Abort
            </FileActionButton>
          </div>
        )}
        {offLine && <div className="label">Uploads will be sent when you are back online</div>}
      </div>
    </div>
  );
};

export default FileUploadProgress;

FileUploadProgress.defaultProps = {
  cancelUpload: () => {},
};

FileUploadProgress.propTypes = {
  currentFile: PropTypes.object.isRequired,
  progress: PropTypes.shape({
    loaded: PropTypes.number,
    humanSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  uploadState: PropTypes.shape({
    uploading: PropTypes.bool,
    uploaded: PropTypes.bool,
    storableValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    uploadedFileName: PropTypes.string,
  }).isRequired,
  cancelUpload: PropTypes.func,
};
